import { render, staticRenderFns } from "./UploadLearnerComponent.vue?vue&type=template&id=be6518ea"
import script from "./UploadLearnerComponent.vue?vue&type=script&lang=js"
export * from "./UploadLearnerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports